<form class="bi-widget-config-editor-content" [formGroup]="formGroup">
    <ui-section [title]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CARD_TITLE.GENERAL' | translate">
        <ui-section-content>
            <div class="grid-container grid-3">
                <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.DATA_SOURCE' | translate">
                    <ui-select
                        formControlName="dataSource"
                        labelField="name"
                        valueField="dataSourceCode"
                        groupField="group"
                        [hideSearch]="false"
                        [options]="(businessIntelligenceDataSources$ | async) ?? []"
                        [required]="true"
                        [disabled]="isEditing"
                        (valueManuallyChange)="onDataSourceChange()"
                    />
                    <ui-form-error>{{ 'ERRORS.FORM.REQUIRED' | translate }}</ui-form-error>
                </ui-form-field>

                <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.TITLE' | translate">
                    <input advizeoInput type="text" formControlName="title" />
                </ui-form-field>

                <ui-form-field class="grid-row-1" [label]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CONFIGURATION.SUBTITLE' | translate">
                    <input advizeoInput type="text" formControlName="subtitle" />
                </ui-form-field>
            </div>
        </ui-section-content>
    </ui-section>

    <ui-section [title]="'TAILORED_WIDGET.BUSINESS_INTELLIGENCE.CARD_TITLE.FILTERS' | translate">
        <ui-section-content>
            <path-list [disableAdding]="!(memberList$ | async)?.length" (addClicked)="addFilter()">
                @for (filterControl of formGroup.controls.filters.controls; track filterControl; let i = $index) {
                    <path-list-item (removed)="removeFilter(i)">
                        <business-intelligence-filter-editor
                            [availableMembers]="(memberList$ | async) ?? []"
                            [filter]="filterControl.value"
                            (filterChanged)="filterControl.setValue($event)"
                        />
                    </path-list-item>
                }
            </path-list>
        </ui-section-content>
    </ui-section>

    <business-intelligence-widget-representation-config-editor
        [availableDimensions]="(representableDimensionList$ | async) ?? []"
        [availableMeasures]="(measureList$ | async) ?? []"
        [representationWidgetConfig]="representationWidgetConfig$ | async"
        [disabled]="!formGroup.value.dataSource"
        [resetNeeded$]="resetIsNeeded$"
        (configChanged)="representationConfigChanged($event)"
    />
</form>
